interface SuggestedPrompt {
    icon: string;
    label: string;
    prompt: string;
}

export const AGENT_CHAT_SUGGESTED_PROMPTS: readonly SuggestedPrompt[] = [
    {
        icon: "💰",
        label: "Revenue",
        prompt: "Show my revenue for this year vs. last year",
    },
    {
        icon: "📦",
        label: "Supplies",
        prompt: "What did I spend on supplies last quarter?",
    },
    {
        icon: "📈",
        label: "Cost of revenue",
        prompt: "Break down my cost of revenue this year",
    },
    {
        icon: "💼",
        label: "General business expenses",
        prompt: "Summarize my general business expenses for this year",
    },
    {
        icon: "🧾",
        label: "Top vendors",
        prompt: "What are my top vendors this year to date?",
    },
    {
        icon: "🔥",
        label: "Net burn",
        prompt: "What is our net burn so far this year?",
    },
    {
        icon: "❓",
        label: "P&L vs. balance sheet",
        prompt: "What's the difference between a P&L and a balance sheet?",
    },
] as const;
